class OpeningUnit {
	constructor(wrapper){
		this._createElements(wrapper);
		this._add();
	}

	_createElements(wrapper){
		this.wrapper = wrapper;
		this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.btn = document.querySelector('[data-openingUnit-btn="'+ this.param.name +'"]');
		this.frame = this.wrapper.querySelector('[data-openingUnit-frame]');
		this.isOpen = false;
	}

	_add(){
		var self = this;
		this.btn.onclick = function(){
			self._shangeShow.call(self);
			return false;
		}
	}

	_shangeShow(){
		if(this.isOpen) {
			this.isOpen = false;
			this.wrapper.style.height = '0px';
			this.btn.className = this.btn.className.replace(/\s*g-active/, '');
		}
		else{
			this.isOpen = true;
			var h = this.frame.getBoundingClientRect().bottom - this.frame.getBoundingClientRect().top;
			this.wrapper.style.height = h + 'px';
			this.btn.className = this.btn.className.replace(/\s*g-active/, '') + ' g-active';
		}
		return false;
	}
};

export {OpeningUnit};